const RequestStatus = {
  Ingresado: 1,
  Aprobado: 2,
  Rechazado: 3,
  Agendado: 4,
  Parcial: 5,
  Borrador: 6,
  Eliminado: 7
};

export default RequestStatus;